import { InfoTooltip } from "@/components/WTooltip.tsx";
import { ReportingErrorBoundary } from "@/modules/error/ReportingErrorBoundary.tsx";
import { errorToReactMessage } from "@/modules/notifications/errorToReactMessage.tsx";
import { isStorybook } from "@/utils/environment.ts";
import { Trans } from "@lingui/react/macro";
import { Children, Suspense, type ReactNode, type SuspenseProps } from "react";

interface IsolatedProps {
    fallback?: SuspenseProps["fallback"];
}

const IsolatedError = ({ error }: { error: unknown }) => (
    <InfoTooltip
        text={errorToReactMessage(error)}
        // Open error description automatically on Storybook for debugging
        isOpen={isStorybook}
    >
        <span className="text-error">
            <Trans>Error</Trans>
        </span>
    </InfoTooltip>
);

/** Wrapper component to isolate components from each other - contains an error boundary and suspense */
export function Isolated({ children, fallback }: { children: ReactNode } & IsolatedProps) {
    return (
        <ReportingErrorBoundary FallbackComponent={IsolatedError} tags="Isolated">
            <Suspense fallback={fallback}>{children}</Suspense>
        </ReportingErrorBoundary>
    );
}

export function IsolatedChildren({ children, ...props }: { children: ReactNode[] } & IsolatedProps) {
    return Children.map(children, (child) => <Isolated {...props}>{child}</Isolated>);
}
